export default __webpack_public_path__ + "static/media/drama-round-b-voter.826b033a.svg";